(() => {
    let el = document.getElementById('loading-overlay');
    if (!el) {
        el = document.createElement('div');
        el.id = 'loading-overlay';
        el.className = 'loading-overlay';
        el.innerHTML = '<div class="loading-overlay__spinner" role="status" aria-label="Chargement"></div>';
        document.body.appendChild(el);
    }
    window.overlay = {
        show(){ el.classList.add('is-open'); document.body.classList.add('no-scroll'); },
        hide(){ el.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
    };
})();
